import { FloatingLabelSelect, FormButton } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class SupportEdit extends EditPage {
  static statusOptions = [
    { value: 'open', label: 'Open' },
    { value: 'inProgress', label: 'In Progress' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'closed', label: 'Closed' }
  ];

  static priorityOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'urgent', label: 'Urgent' }
  ];

  static timlComponents = {
    ...EditPage.timlComponents,
    FloatingLabelSelect,
    FormButton
  };

  static get formAction() {
    return API.resourceUrl('support', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Support" href="/support" nameHref="/support/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.fade.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/support"]
      <FloatingLabelInput label="Subject" name="subject">
      <FloatingLabelTextarea label="Message" name="message" rows="8">
      <FloatingLabelSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}">
      <FloatingLabelSelect label="Priority" name="priority" options="{{ Routing.routeObject.priorityOptions }}">
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('support', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.subject;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
